import { useMemo } from 'react'
import { Trans, useLingui } from '@lingui/react/macro'
import { getFragment, SharedAPI } from '@guestgoodie/graphql'

import * as Form from '@/features/form'
import { useOrganization } from '@/features/organization'
import Name from './Name'
import Logo from './Logo'
import HotelImage from './HotelImage'
import Colors from './Colors'
import Messages from './Messages'
import Font from './Font'
import Location from './Location'
import { graphqlToForm } from '@/features/translations'
import { ProgressBar } from '@/components/ui/ProgressBar'
import ButtonRows from './ButtonRows'

import useBranding, {
  FormData,
  TRANSLATABLE_FIELDS
} from '../hooks/useBranding'

export default function BrandingForm() {
  const { t } = useLingui()
  const { branding, update, errors, loading, progress } = useBranding()
  const { organization } = useOrganization()

  const valuesWithLocales = useMemo(() => {
    return Object.fromEntries(
      Object.entries(branding).filter(([key]) => !key.startsWith('locale'))
    )
  }, [branding])

  return (
    <Form.Root<FormData>
      serverErrors={errors}
      defaultValues={{
        ...valuesWithLocales,
        translations: graphqlToForm(
          getFragment(
            SharedAPI.translation.TRANSLATION_FRAGMENT,
            branding.translations
          ) ?? [],
          TRANSLATABLE_FIELDS,
          branding.supportedLocales ?? []
        )
      }}
      onSubmit={update}
    >
      <div className="relative flex h-full flex-col gap-5 max-w-full">
        <div className="flex flex-row justify-end pr-5">
          <div>
            <Form.Submit loading={loading} onlyValidWhenDirty>
              <Trans>Save</Trans>
            </Form.Submit>
          </div>
        </div>
        {progress != null && (
          <ProgressBar value={progress} title={t`Upload Files`} />
        )}
        <div className="h-full flex-1 overflow-y-auto pb-5 pr-5">
          <div className="flex flex-col gap-4">
            <Name name={organization.name} slug={organization.slug} />
            <Location />
            <Logo />
            <HotelImage />
            <Font />
            <Colors />
            <ButtonRows />
            <Messages />
          </div>
        </div>
      </div>
    </Form.Root>
  )
}
